(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xxxl-product-gallery"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('xxxl-gallery-fan-card')) {
    customElements.define('xxxl-gallery-fan-card', class extends HTMLElement {
      connectedCallback() {
        if (this._abort) return;
        this._abort = new AbortController();
        this.addEventListener('click', (event) => {
          const choice = event.target instanceof Element ? event.target.closest('[data-xxxl-size-choice]') : null;
          if (!choice || !this.contains(choice) || choice.disabled) return;
          event.preventDefault();
          event.stopPropagation();
          this.querySelectorAll('[data-xxxl-size-choice]').forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
          const price = this.querySelector('[data-xxxl-price]');
          const from = this.querySelector('[data-xxxl-from]');
          const compare = this.querySelector('[data-xpg-compare]');
          const saving = this.querySelector('[data-xpg-saving]');
          if (compare) { compare.textContent = choice.dataset.comparePrice || ''; compare.hidden = choice.dataset.onSale !== 'true'; }
          if (saving && saving.dataset.customPromo !== 'true') { saving.textContent = 'SAVE ' + (choice.dataset.savingPrice || ''); saving.hidden = choice.dataset.onSale !== 'true'; }
          if (price) price.textContent = choice.dataset.price;
          if (from) from.dataset.visible = choice.dataset.showFrom;
          this.querySelectorAll('[data-xxxl-product-link]').forEach(link => link.setAttribute('href', choice.dataset.variantUrl));
        }, { signal: this._abort.signal });
      }
      disconnectedCallback() { this._abort?.abort(); this._abort = null; }
    });
  }

if (!customElements.get('xxxl-product-gallery')) {
  customElements.define('xxxl-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this._xpgAbort || this._xpgFrame) return;
      this._xpgFrame = requestAnimationFrame(() => { this._xpgFrame = null; this.setupGallery(); });
    }

    setupGallery() {
      if (!this.isConnected || this._xpgAbort) return;
      const viewport = this.querySelector('[data-xpg-viewport]');
      const cards = [...this.querySelectorAll('[data-xpg-card]')];
      if (!viewport || !cards.length) return;
      this._xpgAbort = new AbortController();
      const signal = this._xpgAbort.signal;
      const prev = this.querySelector('[data-xpg-prev]');
      const next = this.querySelector('[data-xpg-next]');
      const current = this.querySelector('[data-xpg-current]');
      const total = this.querySelector('[data-xpg-total]');
      const progress = this.querySelector('[data-xpg-progress]');
      const footer = this.querySelector('[data-xpg-footer]');
      const mobile = () => window.matchMedia('(max-width:749px)').matches;
      const horizontal = () => mobile() ? this.dataset.layoutMobile === 'carousel' : this.dataset.layoutDesktop === 'carousel';
      const behavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const step = () => {
        const a = cards[0].getBoundingClientRect();
        const b = cards[1]?.getBoundingClientRect();
        return Math.max(1, b && b.left > a.left ? b.left - a.left : a.width || viewport.clientWidth);
      };
      const perView = () => {
        if (!horizontal()) return cards.length;
        const gap = parseFloat(getComputedStyle(viewport.querySelector('.xpg-track')).columnGap) || 0;
        return Math.max(1, Math.min(cards.length, Math.floor((viewport.clientWidth + gap + 1) / step())));
      };
      const update = () => {
        const visible = perView();
        const maxIndex = Math.max(0, cards.length - visible);
        const index = horizontal() ? Math.min(maxIndex, Math.max(0, Math.round(viewport.scrollLeft / step()))) : 0;
        if (current) current.textContent = String(index + 1).padStart(2, '0');
        if (total) total.textContent = String(cards.length).padStart(2, '0');
        if (prev) prev.disabled = !horizontal() || index === 0;
        if (next) next.disabled = !horizontal() || index >= maxIndex;
        if (footer) footer.hidden = !horizontal() || maxIndex === 0;
        this.classList.toggle('xpg-no-scroll', !horizontal() || maxIndex === 0);
        if (progress) {
          const width = visible / cards.length * 100;
          const shift = maxIndex ? index / maxIndex * (100 - width) : 0;
          progress.style.width = width + '%';
          progress.style.transform = `translateX(${width ? shift / (width / 100) : 0}%)`;
        }
      };
      const move = direction => { if (horizontal()) viewport.scrollBy({ left: direction * step(), behavior: behavior() }); };
      prev?.addEventListener('click', () => move(-1), { signal });
      next?.addEventListener('click', () => move(1), { signal });
      viewport.addEventListener('scroll', update, { passive: true, signal });
      window.addEventListener('resize', update, { passive: true, signal });
      if (typeof ResizeObserver !== 'undefined') {
        this._xpgObserver = new ResizeObserver(update);
        this._xpgObserver.observe(viewport);
      }

      function setupMouseDrag(viewport, canDrag, onFinish, signal) {
        let pointer = null;
        let dragging = false;
        let startX = 0;
        let startY = 0;
        let startScroll = 0;
        let suppressClick = false;
        let clickTimer = null;
        const clearClick = () => {
          suppressClick = false;
          if (clickTimer !== null) clearTimeout(clickTimer);
          clickTimer = null;
        };
        const release = () => {
          const id = pointer;
          pointer = null;
          dragging = false;
          viewport.classList.remove('is-dragging');
          if (id !== null) {
            try { if (viewport.hasPointerCapture(id)) viewport.releasePointerCapture(id); } catch (_) {}
          }
        };
        const finish = event => {
          if (pointer === null || (event && event.pointerId !== undefined && event.pointerId !== pointer)) return;
          const wasDragging = dragging;
          release();
          if (!wasDragging) return;
          suppressClick = true;
          clickTimer = setTimeout(clearClick, 500);
          onFinish?.();
        };
        viewport.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          clearClick();
          const target = event.target instanceof Element ? event.target : null;
          if (!canDrag() || viewport.scrollWidth <= viewport.clientWidth + 2 || !target || target.closest('button,input,select,textarea,label,summary,[role="button"],[contenteditable]:not([contenteditable="false"])')) return;
          pointer = event.pointerId;
          startX = event.clientX;
          startY = event.clientY;
          startScroll = viewport.scrollLeft;
        }, { signal });
        window.addEventListener('pointermove', event => {
          if (pointer === null || event.pointerId !== pointer) return;
          if (!(event.buttons & 1)) { finish(event); return; }
          const delta = event.clientX - startX;
          if (!dragging) {
            if (Math.abs(delta) < 6 || Math.abs(delta) <= Math.abs(event.clientY - startY)) return;
            dragging = true;
            viewport.classList.add('is-dragging');
            try { viewport.setPointerCapture(pointer); } catch (_) {}
          }
          event.preventDefault();
          viewport.scrollLeft = startScroll - delta;
        }, { capture: true, passive: false, signal });
        for (const name of ['pointerup', 'pointercancel']) window.addEventListener(name, finish, { capture: true, signal });
        viewport.addEventListener('lostpointercapture', finish, { signal });
        window.addEventListener('blur', () => finish(null), { signal });
        viewport.addEventListener('dragstart', event => {
          if (pointer !== null) event.preventDefault();
        }, { signal });
        viewport.addEventListener('click', event => {
          if (!suppressClick || event.detail === 0) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          clearClick();
        }, { capture: true, signal });
        signal.addEventListener('abort', () => { release(); clearClick(); }, { once: true });
      }

      if (this.dataset.dragEnabled === 'true') {
        setupMouseDrag(viewport, horizontal, () => {
          const maxIndex = Math.max(0, cards.length - perView());
          const index = Math.min(maxIndex, Math.max(0, Math.round(viewport.scrollLeft / step())));
          viewport.scrollTo({ left: index * step(), behavior: behavior() });
        }, signal);
      }
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-xpg-card]');
        if (!card || !this.contains(card)) return;
        if (horizontal()) {
          const left = card.getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft;
          viewport.scrollTo({ left, behavior: behavior() });
        } else {
          card.scrollIntoView({ behavior: behavior(), block: 'nearest', inline: 'nearest' });
        }
      }, { signal });
      update();
    }

    disconnectedCallback() {
      if (this._xpgFrame) cancelAnimationFrame(this._xpgFrame);
      if (this._xpgClickTimer) clearTimeout(this._xpgClickTimer);
      this._xpgFrame = null; this._xpgClickTimer = null;
      this._xpgObserver?.disconnect(); this._xpgObserver = null;
      this._xpgAbort?.abort(); this._xpgAbort = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
